/* Oergezond luxe PDP: "Andere oerproducten". Mengt Shopify-aanbevelingen met de vaste lijst en voegt snel toe aan de Kaching slide cart. */
(function () {
  var MAX = 4;

  function arr(list) { return Array.prototype.slice.call(list || []); }

  function merge(sec, recCards) {
    var track = sec.querySelector('[data-lx-rel-track]');
    if (!track) return;
    var cat = sec.getAttribute('data-cat');
    var current = sec.getAttribute('data-current');
    var fb = arr(track.querySelectorAll('.lx-rel__card'));
    var same = function (c) { return c.getAttribute('data-cat') === cat; };
    var order = [].concat(
      recCards.filter(same), fb.filter(same),
      fb.filter(function (c) { return !same(c); }), recCards.filter(function (c) { return !same(c); })
    );
    var seen = {}, pick = [];
    order.forEach(function (c) {
      var h = c.getAttribute('data-handle');
      if (!h || h === current || seen[h] || pick.length >= MAX) return;
      seen[h] = 1; pick.push(c);
    });
    if (pick.length < 2) return; // te weinig: laat de serverlijst staan
    var frag = document.createDocumentFragment();
    pick.forEach(function (c) { frag.appendChild(c); });
    track.innerHTML = '';
    track.appendChild(frag);
  }

  function loadRecs(sec) {
    var url = sec.getAttribute('data-url');
    if (!url || !window.fetch) return;
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cards = arr(doc.querySelectorAll('[data-lx-rel-recs] .lx-rel__card')).map(function (c) { return document.importNode(c, true); });
        if (cards.length) merge(sec, cards);
      })
      .catch(function () {});
  }

  function openCart() {
    var api = window.kachingCartApi;
    if (api && typeof api.openCart === 'function') {
      try {
        var p = typeof api.refreshCart === 'function' ? api.refreshCart() : null;
        if (p && typeof p.then === 'function') p.then(function () { api.openCart(); }, function () { api.openCart(); });
        else api.openCart();
        return true;
      } catch (e) {}
    }
    try { document.dispatchEvent(new CustomEvent('kaching-cart:open')); } catch (e) {}
    return false;
  }

  function add(btn) {
    var id = btn.getAttribute('data-lx-add');
    if (!id) return;
    var txt = btn.querySelector('.lx-rel__btn-txt') || btn;
    btn.setAttribute('aria-busy', 'true');
    txt.textContent = 'Even geduld';
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw new Error('add ' + r.status); return r.json(); })
      .then(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-done');
        txt.textContent = 'Toegevoegd';
        document.dispatchEvent(new CustomEvent('lx:cart-added', { detail: { variantId: Number(id) } }));
        if (!openCart()) { window.location.href = root + 'cart'; return; }
        setTimeout(function () { btn.classList.remove('is-done'); txt.textContent = 'In winkelmand'; }, 2600);
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        btn.classList.add('is-error');
        txt.textContent = 'Niet gelukt, probeer opnieuw';
        setTimeout(function () { btn.classList.remove('is-error'); txt.textContent = 'In winkelmand'; }, 3000);
      });
  }

  function init() {
    arr(document.querySelectorAll('[data-lx-rel]')).forEach(function (sec) {
      if (sec.__lxRel) return;
      sec.__lxRel = true;
      sec.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-lx-add]');
        if (!btn) return;
        e.preventDefault();
        add(btn);
      });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (en) {
          if (en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); loadRecs(sec); }
        }, { rootMargin: '800px 0px' });
        io.observe(sec);
      } else loadRecs(sec);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
